import { v4 as uuidv4 } from 'uuid'

export const uuid = uuidv4()

export const addSessionId = <T>(
  body?: T | undefined
): (T & { sessionId: string }) | { sessionId: string } => {
  return body ? { ...body, sessionId: uuid } : { sessionId: uuid }
}
